<script lang="ts">
  import { Snackbar, Button } from 'svelte-materialify';
  import { alert } from '../store';
</script>

{#each $alert as alertItem, index}
  <Snackbar absolute bottom center tile>
    <div class="toast-container">
      <button
        class="close"
        type="button"
        on:click={() => {
          alert.hide(index);
        }}>&#10005;</button
      >
      <div>
        <span>{alertItem.message}</span>
        {#if alertItem.buttonLabel}
          <Button
            class="error-text"
            text
            on:click={() => {
              alertItem.buttonAction();
              alert.hide(index);
            }}
          >
            {alertItem.buttonLabel}
          </Button>
        {/if}
      </div>
    </div>
  </Snackbar>
{/each}

<style lang="scss">
  .toast-container {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    padding-left: 16px;
    padding-right: 16px;
  }
  .close {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    opacity: 0.3;
  }
  .close:hover {
    opacity: 1;
  }
  .close:before,
  .close:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 33px;
    width: 2px;
    background-color: #333;
  }
  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }
  :global(.s-snackbar__wrapper .s-snackbar) {
    min-width: initial;
  }
</style>
